import maleSVG from '../../assets/images/profile-male.svg'
import linkedin from '../../assets/images/linkedin.png'
import twitter from '../../assets/images/twitter.png'
import facebook from '../../assets/images/facebook.png'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { getJuryDetailsAdminById } from '../../services/admin.service'
import { useEffect, useState } from 'react'

export const JuryMemberAboutAdmin = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const [juryData, setJuryData] = useState()
    const [juryName, setJuryName] = useState("")
    const [juryDesignation, setJuryDesignation] = useState()
    const [juryIdeaCategory, setJuryIdeaCategory] = useState()
    const [juryAbout, setJuryAbout] = useState()

    const getJuryDetailAdmin = async () => {
        const { status, data } = await getJuryDetailsAdminById(id)
        if (status == 200) {
            if (data.length == 0) {
                navigate('/')
            } else {
                const juryData = data[0]
                setJuryName(juryData.NAME)
                setJuryDesignation(juryData.DESIGNATION)
                setJuryIdeaCategory(juryData.idea_category)
                setJuryAbout(juryData.JURY_BIO)
            }
        }

    }

    useEffect(() => {
        getJuryDetailAdmin()
    }, [])
    return (
        <>
            <div className="app-content content">
                <div className="content-overlay" />
                <div className="header-navbar-shadow" />
                <div className="content-wrapper">
                    <div className="content-body">
                        <div className="row">
                            <div className="col-lg-6 col-12">
                                <h2 className="mb-0">{juryName}</h2>
                                <p className="font-lato font-12">Jury management</p>
                            </div>
                            {/* <div className="col-lg-6 col-12 text-right">
                                <Link
                                    to={`/jury-list/about/${id}/edit`}
                                    className="btn btn-primary font-lato text-white rounded-10 font-11 waves-effect waves-float waves-light"
                                >
                                    <i className="fas fa-edit mr-1" />
                                    Edit profile
                                </Link>
                            </div> */}
                        </div>
                        <div className="row">
                            <div className="col-12 col-lg-3">
                                <div className="card card-profile">
                                    <div className="card-body">
                                        <div className="profile-image-wrapper">
                                            <div className="starshot-ring">
                                                <div className="avatar">
                                                    <div className="text-icon font-lato font-32 w-50p h-50p">{juryName[0]}</div>
                                                </div>
                                            </div>

                                        </div>
                                        <h3>{juryName}</h3>
                                        <h6 className="opacity-50">{juryDesignation}</h6>
                                        <hr className="my-1 mx-4" />
                                        <div className="row text-center">
                                            <div className="col-12">
                                                <h6 className="text-p-light-blue mb-0">Idea Category</h6>
                                                <h6 className="mb-0">{juryIdeaCategory}</h6>
                                            </div>
                                        </div>
                                        <hr className="my-1 mx-4" />
                                        <div className="row text-center">
                                            <div className="col-6">
                                                <a>
                                                    <p className="mb-0 font-20 font-weight-600">0</p>
                                                    <p className="mb-0 opacity-50 font-weight-600 font-11 font-lato">
                                                        Approved
                                                    </p>
                                                </a>
                                            </div>
                                            <div className="col-6">
                                                <a >
                                                    <p className="mb-0 font-20 font-weight-600">0</p>
                                                    <p className="mb-0 opacity-50 font-weight-600 font-11 font-lato">
                                                        Rejected
                                                    </p>
                                                </a>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center mt-1 p-2">
                                            <div>
                                                <img
                                                    src={linkedin}
                                                    alt="img"
                                                    width={18}
                                                    height={18}
                                                />
                                            </div>
                                            <div>
                                                <img
                                                    src={twitter}
                                                    alt="img"
                                                    width={18}
                                                    height={18}
                                                />
                                            </div>
                                            <div>
                                                <img
                                                    src={facebook}
                                                    alt="img"
                                                    width={18}
                                                    height={18}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-9">
                                <div className="card">
                                    <div className="card-body">
                                        <h4>ABOUT</h4>
                                        <p className="font-lato font-13">
                                            {juryAbout}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="footer">
                                    <p className="mb-0">©2025 Protiviti Inc. All Rights Reserved.</p>
                                    <p className="mb-0">
                                        Protiviti Inc. is an Equal Opportunity Employer,
                                        M/F/Disability/Vet
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}